export default __webpack_public_path__ + "static/media/logo.d2c148c9.jpg";